import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "card-outlined p-4" }
const _hoisted_3 = { class: "text-subtitle-underline" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  for: "name",
  class: "form-label"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "form-error-text" }
const _hoisted_8 = { class: "pt-4 pb-2 flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_alert, { class: "mb-4" }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.t('account.change_name.title')), 1),
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('word.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                    id: "name",
                    name: "name",
                    type: "text",
                    placeholder: _ctx.t('word.name'),
                    class: _normalizeClass(`form-input mb-1 ${_ctx.errors['name'] ? 'border-red-500' : ''}`)
                  }, null, 10, _hoisted_6), [
                    [_vModelText, _ctx.name]
                  ]),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errors['name']), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_base_form_submit, {
                    disabled: _ctx.btnDisabled,
                    text: _ctx.t('word.change')
                  }, null, 8, ["disabled", "text"])
                ])
              ], 32)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}